// extracted by mini-css-extract-plugin
export default {"metadataContainer":"executionDetail_metadataContainer__2JI74","inputOutputContainer":"executionDetail_inputOutputContainer__nOrNo"};